import React from 'react';
import Modal from '@components/common/Modal';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import cn from 'classnames';
import style from './viewreceipt.module.scss';
import { flowType } from '../../utility/userInfo';

const TipsConfirmPopUp = ({
  isOpen, onClose, onSubmitTips,
  tipAmount,
  totalAmount,
  totalAmountForTip,
  supportsWarnOnUnusualTip
}) => {
  const currencySymbol = LABEL().CURRENCY_SYMBOL;
  const isServerApp = flowType() === 'serverApp';
  const checkDecimal = (val) => {
    const newValdata = val.toString().split('.')
    if (newValdata[1]) {
      const newstr = newValdata[1].substring(0,1)
      if (Number(newstr) > 0) {
        return Number(val).toFixed(1)
      } else {
        return newValdata[0]
      }
    }
    return val
  }
  return (
    <Modal
      isOpen={isOpen}
      customClass3 = {cn(style.tipPopupH)}
      isModalCenter
      
    >
      <div className={((checkDecimal(((Number(tipAmount) / totalAmountForTip) * 100).toFixed(1)) > 30) && supportsWarnOnUnusualTip) ? cn('col-12 d-flex justify-content-center flex-column p-3 align-items-center position-relative text-center') : cn('col-12 p-3 d-flex  flex-column justify-content-center align-items-center position-relative text-center')}
       style={{backgroundColor: '#292C2D', color: '#ffffff', fontFamily: 'Poppins', border: checkDecimal((((Number(tipAmount) / totalAmountForTip) * 100).toFixed(1)) > 30) && supportsWarnOnUnusualTip ? '2px solid red' : '1px solid var(--popup-stock, #9F9F9F)', borderRadius: '16px', boxShadow: '0px 8px 36px 0px rgba(0, 0, 0, 0.16)'}}
      >
        {checkDecimal(((Number(tipAmount) / totalAmountForTip) * 100).toFixed(1)) > 30 ? (
          <div className="col-12 fw-600">
            <div className="text-center justify-content-center">
              <div style={{fontSize:'Max(2.2vw, 2.2vh)'}}>Tip amount {currencySymbol}{Number(tipAmount).toFixed(2)} ({checkDecimal(((Number(tipAmount) / totalAmountForTip) * 100).toFixed(1))}%) is more than 30%. <br/>{CUSTOM_MESSAGES().Do_you_want_to_continue?CUSTOM_MESSAGES().Do_you_want_to_continue:'Do you want to continue ?'}</div>
            </div>
          </div>
        ) : (
          <div className="col-12 fw-600">
            <div className="text-center justify-content-center">
              <div style={{fontSize:'Max(2.2vw, 2.2vh)'}}>Tip amount of {currencySymbol}{Number(tipAmount).toFixed(2)} is {checkDecimal(((Number(tipAmount) / totalAmountForTip) * 100).toFixed(1))}%.<br/> Is this correct ?</div>
            </div>
          </div>
        )}
        <br/>
        <div className="col-12 d-flex justify-content-center w-85 pr-0 h-10 pl-0">
          <button type="submit" className={cn("col-6 m-1 btn od-btn-secondary", style.btnSecondary)} onClick={() => onClose(false)}>
            <div style={{fontSize: isServerApp ? "28px" :"20px"}}>{LABEL().NO}</div>
          </button>
          <button type="submit" className={cn("col-6 m-1 btn btn-ripple btn-lg od-btn-primary", style.btnPrimary)} onClick={() => { onSubmitTips(); }}>
            <div style={{fontSize: isServerApp ? "28px" : "20px"}}>{LABEL().YES}</div>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default TipsConfirmPopUp;
